// Copyright 2025, University of Maryland, All Rights Reserved
import { Switch } from "@/components/ui/switch"
import { Label } from "@/components/ui/label"
import { SessionDisplay } from '@/components/SessionDisplay'
import type { APISession } from '@/types/session'

interface SessionSyncControlsProps {
  session: APISession
  sessionEnabled: boolean
  isExpanded: boolean
  isMutating: boolean
  onSyncToggle: (session: APISession, enabled: boolean) => void
  onToggleExpanded: () => void
}

export function SessionSyncControls({
  session,
  sessionEnabled,
  isMutating,
  onSyncToggle
}: SessionSyncControlsProps) {
  return (
    <div className="border rounded-lg overflow-hidden">
      {/* Main session row with sync toggle*/}
      <div className="flex items-center justify-between p-3 hover:bg-slate-50 dark:hover:bg-slate-800/50">
        <div className="flex items-center gap-3 flex-1">
          <div className={`w-2 h-2 rounded-full ${sessionEnabled ? 'bg-green-500' : 'bg-slate-300'}`}></div>
          <SessionDisplay session={session} />
        </div>
        
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Label htmlFor={`sync-${session}`} className="text-xs text-slate-600 dark:text-slate-400">
              Sync
            </Label>
            <Switch
              id={`sync-${session}`}
              checked={sessionEnabled}
              onCheckedChange={(enabled) => onSyncToggle(session, enabled)}
              disabled={isMutating}
            />
          </div>
        </div>
      </div>

    </div>
  )
}
